import { isFiniteNumber } from '@core';

type Params = {
    min?: number;
    max?: number;
    step: number;
    onUpdate?: (p: { min?: number; max?: number }) => void;
};

export function useGoalRange({ min, max, step, onUpdate }: Params) {
    const safeMin = isFiniteNumber(min) ? min : undefined;
    const safeMax = isFiniteNumber(max) ? max : undefined;

    const update = (next: Partial<{ min?: number; max?: number }>) => onUpdate?.({ min, max, ...next });

    const epsilon = 1e-6;

    const minControls = {
        canIncrement: safeMin !== undefined && safeMax !== undefined && safeMin + step < safeMax - epsilon,
        canDecrement: safeMin !== undefined,
        increment: () => safeMin !== undefined && update({ min: safeMin + step }),
        decrement: () => safeMin !== undefined && update({ min: safeMin - step }),
        update: (value?: number) => update({ min: value }),
    };

    const maxControls = {
        canIncrement: safeMax !== undefined,
        canDecrement: safeMin !== undefined && safeMax !== undefined && safeMax - step > safeMin + epsilon,
        increment: () => safeMax !== undefined && update({ max: safeMax + step }),
        decrement: () => safeMax !== undefined && update({ max: safeMax - step }),
        update: (value?: number) => update({ max: value }),
    };

    return { min: minControls, max: maxControls };
}
